export const enum MutationNames {
  updatePatientWithEvents = 'PATIENT_WITH_EVENTS_UPDATE_PATIENT_WITH_EVENTS',
}

export const enum ActionNames {
  getPatientWithEvents = 'PATIENT_WITH_EVENTS_GET_PATIENT_WITH_EVENTS',
  getPatientWithEventsById = 'PATIENT_WITH_EVENTS_GET_PATIENT_WITH_EVENTS_BY_ID',
}

export const enum GetterNames {
  patientWithEvents = 'PATIENT_WITH_EVENTS_PATIENT_WITH_EVENTS',
  patientWithRecentEvents = 'PATIENT_WITH_EVENTS_PATIENT_WITH_RECENT_EVENTS',
  patientWithUrgentEvents = 'PATIENT_WITH_EVENTS_PATIENT_WITH_URGENT_EVENTS',
  patientWithNewChangesEvents = 'PATIENT_WITH_EVENTS_PATIENT_WITH_NEW_CHANGES_EVENTS',
}
